import { FlexContainer } from '@taxdown/piccolo-web';
import styled from 'styled-components';

export const WarningItem = styled(FlexContainer)`
  width: 100%;
`;

export const TabHeader = styled(FlexContainer)`
  width: 100%;
  height: 20px;
  svg {
    display: flex;
    align-items: center;
  }
`;
